var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4958_16185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.83343L16.2942 6.93677C16.4212 6.87329 16.5623 6.84333 16.7042 6.84972C16.846 6.85611 16.9839 6.89864 17.1047 6.97327C17.2255 7.0479 17.3252 7.15216 17.3944 7.27616C17.4636 7.40015 17.4999 7.53977 17.5 7.68177V13.3184C17.4999 13.4604 17.4636 13.6 17.3944 13.724C17.3252 13.848 17.2255 13.9523 17.1047 14.0269C16.9839 14.1016 16.846 14.1441 16.7042 14.1505C16.5623 14.1569 16.4212 14.1269 16.2942 14.0634L12.5 12.1668V8.83343Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 5.5H4.16667C3.24619 5.5 2.5 6.24619 2.5 7.16667V13.8333C2.5 14.7538 3.24619 15.5 4.16667 15.5H10.8333C11.7538 15.5 12.5 14.7538 12.5 13.8333V7.16667C12.5 6.24619 11.7538 5.5 10.8333 5.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 10.5H9.16536",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.83325V12.1666",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4958_16185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlus);
export default __webpack_public_path__ + "static/media/video-plus.3505140f08d72a9aa642d7c39ccfffe3.svg";
export { ForwardRef as ReactComponent };